import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter, Routes, Route } from "react-router-dom";
//
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import reportWebVitals from "./reportWebVitals";
import { store } from "./app/store";
import { injectStore } from "./app/api/axios/http.service";
import { setCredentials, logOut } from "./features/auth/authSlice";
import { registerLicense } from "@syncfusion/ej2-base";
// import { disableReactDevTools } from '@fvilers/disable-react-devtools';

// Wire the Redux store into the axios interceptors before any request is made.
// Must be here (not inside a component) to avoid the store → apiSlice → http.service circular import.
injectStore(store, { setCredentials, logOut });

registerLicense(
  "Ngo9BigBOggjHTQxAR8/V1NDaF5cWWtCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWH5cd3RQRGleV0V2Wks=",
);

// ----------------------------------------------------------------------

// if (process.env.NODE_ENV === 'production') disableReactDevTools()

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route path="/*" element={<App />} />
        </Routes>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
);

// If you want to enable client cache, register instead.
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
